import {Country} from "../../../../region/types/Country";

export interface IGetGTMEcommerceSpainParams {
    distance_from_the_airport?: number | null;
    distance_from_the_beach?: number | null;
}

export const getGTMEcommerceSpainParams = (country?: Country, params?: IGetGTMEcommerceSpainParams) => {
    if (country === Country.SPAIN) {
        return {
            ...(params?.distance_from_the_airport
                ? {
                      item_airport_distance: params.distance_from_the_airport.toString()
                  }
                : {}),
            ...(params?.distance_from_the_beach
                ? {
                      item_beach_distance: params.distance_from_the_beach.toString()
                  }
                : {})
        };
    }

    return {};
};
import {Country} from "../../../../region/types/Country";

export interface IGetGTMEcommerceSpainParams {
    distance_from_the_airport?: number | null;
    distance_from_the_beach?: number | null;
}

export const getGTMEcommerceSpainParams = (country?: Country, params?: IGetGTMEcommerceSpainParams) => {
    if (country === Country.SPAIN) {
        return {
            ...(params?.distance_from_the_airport
                ? {
                      item_airport_distance: params.distance_from_the_airport.toString()
                  }
                : {}),
            ...(params?.distance_from_the_beach
                ? {
                      item_beach_distance: params.distance_from_the_beach.toString()
                  }
                : {})
        };
    }

    return {};
};
